const KEYMAP = {
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,

  'w': 87,
  'a': 65,
  's': 83,
  'd': 68
}

export default class KeyInput {
  constructor () {
    this.keyState = {};
    this._bindings = {};

    document.addEventListener('keydown', (e) => {
      this.keyState[e.keyCode || e.which] = true;
    }, true);

    document.addEventListener('keyup', (e) => {
      this.keyState[e.keyCode || e.which] = false;
    }, true);
  }

  isDown(key) {
    return this.keyState[KEYMAP[key]];
  }

  bindKey (key, handler, context, ...args) {
    this._bindings[key] = {
      handler: handler,
      context: context,
      args: args
    };
  }

  update (t) {
    for (let key in this._bindings) {
      if (this.isDown(key)) {
        this._bindings[key].handler.call(this._bindings[key].context, ...this._bindings[key].args);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/keyInput.js